var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrangement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Arrangement_svg__clip0_1_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.164 6.652l1.265-4.274-6.531 1.266-6.532-1.266 1.265 4.273m10.533 0l-2.179 7.362a7.257 7.257 0 00-3.062-.673 7.257 7.257 0 00-3.106.694L14.63 6.65m10.533 0a14.975 14.975 0 018.696 8.677M14.63 6.651a14.975 14.975 0 00-8.695 8.677m27.924 0l-7.353 2.177c.449.945.7 2.003.7 3.119a7.257 7.257 0 01-.68 3.075l7.35 2.176m-.017-10.547l4.259-1.26-1.266 6.53 1.266 6.532-4.241-1.255M5.936 15.328l-4.26-1.26 1.267 6.53-1.266 6.532 4.24-1.255m.019-10.547l7.397 2.19a7.256 7.256 0 00-.694 3.106c0 1.094.241 2.131.673 3.062l-7.394 2.189m0 0a14.975 14.975 0 008.7 8.719m0 0l-1.252 4.226 6.532-1.266 6.531 1.266-1.25-4.226m-10.562 0l2.187-7.386c.945.449 2.003.7 3.119.7 1.099 0 2.14-.244 3.075-.68l2.18 7.366m0 0a14.975 14.975 0 008.7-8.72m-6.73-5.249a7.25 7.25 0 11-14.5 0 7.25 7.25 0 0114.5 0z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Arrangement_svg__clip0_1_7"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v41H0z"
  })))));
}
export default SvgArrangement;